const ErrorView = () => import('@/Global/views/ErrorView.vue')
const Error404Page = () => import('@/Global/views/404Page.vue')
const ErrorPermissionDenied = () => import('@/Global/views/PermissionDenied.vue')
const ErrorLoggedOut = () => import('@/Global/views/LoggedOut.vue')

const router = [
  {
    path: '/',
    name: 'home',
    redirect: to => {
      return '/login'
    }
  },
  {
    path: '/error',
    name: 'error',
    component: ErrorView,
    children: [
      {
        path: '/permission-denied',
        name: 'errorPermissionDenied',
        component: ErrorPermissionDenied
      },
      {
        path: '/logout',
        name: 'errorLoggedOut',
        component: ErrorLoggedOut
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'error404',
        component: Error404Page
      }
    ]
  }
]

export default router
